import { Store } from "../types/Store";
export const stores: Store[] = [
    {
      id: 1,
      name: "Nisa Local Marchmont Road",
      address: "126 Marchmont Road, Edinburgh, EH9 1AQ",
      website: "https://easyshopscotland.co.uk",
      phone: "+44 (131) 5633406",
      hours: "6:00 AM - 11:00 PM",
      features: ["Groceries", "Chilled Food", "Fresh Produce", "Costa", "PayPoint", "Lottery", "Tobacco", "News & Magazines", "Bakery", "Deli", "Parcel Drop Off", "Alcohol & Wines", "Iceland Frozen", "Barista Coffee", "Breakfast" , "Collect Plus" ],
      homedelivery: ["Just Eat", "Deliveroo", "Snappy Shopper"]
    },      

    {
      id: 2,
      name: "Wee Shop Musselburgh",
      address: "18 Newbigging, Musselburgh, EH21 7AH",
      website: "https://easyshopscotland.co.uk",
      phone: "+44 (131) 5630428",
      hours: "7:00 AM - 10:00 PM",
      features: ["Groceries", "Chilled Food", "Fresh Produce", "PayPoint", "Lottery", "Tobacco", "Bakery", "Alcohol & Wines" , "Iceland Frozen" ],
      homedelivery: ["Just Eat", "Deliveroo" ]

    },
    // {
    //   id: 3,
    //   name: "Magical Spices & Butchers (Coming Soon...)",
    //   address: "138 Marchmont Road, Edinburgh, EH9 1AQ",
    //   hours: "6:00 AM - 11:00 PM",
    //   features: ["Groceries", "Chilled Food", "Fresh Produce", "Asian Spices", "Meat & Fish" ]
    // }
  ];